import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import RecurlyProvider from '@/components/Providers/RecurlyProvider'
import { useSignUp } from '@/components/Providers/SignUpProvider'
import SelectPlan from '@/components/Pages/SignUp/SelectPlan'
import Authenticate from '@/components/Pages/SignUp/Authenticate'
import NewUser from '@/components/Pages/SignUp/NewUser'
import Billing from '@/components/Pages/SignUp/Billing'
import ExistingUser from '@/components/Pages/SignUp/ExistingUser'
import ResetPassword from '@/components/Pages/SignUp/ResetPassword'
import Upsell from '@/components/Pages/SignUp/Upsell'
import Spinner from '@/components/common/FullScreenSpinner'

const SignUpForm = ({ csrfToken }) => {
  const { navigation, isLoading, setCsrfToken } = useSignUp()

  useEffect(() => {
    if (csrfToken) {
      setCsrfToken(csrfToken)
    }
  }, [])

  if (!csrfToken) { return (
    <Spinner>
      <h2>Please reload the page</h2>
    </Spinner>
  ) }

  if (isLoading) { return (
    <Spinner>
      <h2>Loading</h2>
      <p>Please wait...</p>
    </Spinner>
  ) }

  return (
    <RecurlyProvider>
      {
        {
          authenticate: <Authenticate />,
          existingUser: <ExistingUser />,
          resetPassword: <ResetPassword />,
          upsell: <Upsell />,
          selectPlan: <SelectPlan />,
          newUser: <NewUser />,
          billing: <Billing />,
        }[navigation.currentStep]
      }
    </RecurlyProvider>
  )
}

SignUpForm.propTypes = {
  csrfToken: PropTypes.string,
}

export default SignUpForm
